module.exports = __webpack_public_path__ + "img/networkVisual.21836893.png";